<template>
  <div>
    <div class="content-main" v-title data-title="本地登录">
      <div class="login-title">本地用户登录</div>
      <div class="user-name-box">
        <el-input
          placeholder="请输入用户名"
          v-model="userName"
          clearable>
        </el-input>
      </div>
      <div class="user-name-box">
        <el-input placeholder="请输入密码" v-model="userAuth" show-password></el-input>
      </div>
      <div class="verify-code-box">
        <el-input placeholder="请输入验证码" v-model="verifyCode">
          <template slot="append">
            <img v-if="verifyCodeImg" :src="verifyCodeImg" @click="getVerifyCode">
          </template>
        </el-input>
      </div>
      <el-button type="primary" @click="loginDev" :loading="loading">登录</el-button>
    </div>
  </div>
</template>

<script>
import {getRequest, postRequest} from "../../utils/request";
import {showMessage} from "../../utils/notice";
import {postRequestSms} from "../../utils/requestForSms";
import {setStore} from "../../utils/storage";

export default {
  name: "LocalLogin",
  props: {
    //本地登录前访问的地址
    referer: null,
  },
  data() {
    return {
      userName: "zx_zhou",
      userAuth: null,
      verifyCode: null,
      verifyCodeImg: null,
      loading: false,
      disabled: false
    }
  },
  methods: {
    loginDev() {
      if (!this.userName) {
        showMessage("请输入用户名", "error")
        return;
      }
      if (!this.userAuth) {
        showMessage("请输入密码", "error")
        return;
      }
      this.loading = true
      this.disabled = true
      postRequest("/sys/dev/login", {
        username: this.userName,
        password: this.userAuth,
        verifyCode: this.verifyCode,
      }).then(res => {
        this.loading = false
        this.disabled = false
        //登录SMS系统
        return postRequestSms("/login.do", {
          username: this.userName,
          password: this.userAuth
        })
      }).then(res => {
        this.loading = false
        this.disabled = false
        console.log("sms登录成功，res：" + res)
        if (res.success === "true") {
          setStore("smsTokenId", Number(res.tokenid));
          if (this.referer)
            location.href = this.referer;
          else
            this.$router.push("/");
        } else {
          showMessage("error", "sms登录失败，res：" + res.reason);
        }
      }).catch(() => {
        this.loading = false
        this.disabled = false
      })
    },
    getVerifyCode() {
      getRequest("/sys/dev/verify-code").then(res => {
        this.verifyCodeImg = "data:image/png;base64," + res.data.verifyCodeImg;
        if (process.env.autoFillVerifyCode)
          this.verifyCode = res.data.verifyCode;
      })
    },
  },
  mounted() {
    this.getVerifyCode();
  }
}
</script>

<style scoped lang="less">
.content-main {
  background-color: #fff;
  text-align: center;
  border-radius: 10px;
  margin-top: 100px;
}

.user-name-box {
  width: 200px;
  margin: 20px auto;
}

.verify-code-box {
  width: 200px;
  margin: 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/system/LocalLogin.vue